import axios from 'axios';
import {fetchConfig} from '../util/util';

const HOST_URL = fetchConfig('hostUrl')

const getOneById = async (ownerId) => {
  return (await axios.get(`${HOST_URL}/owner/${ownerId}`)).data;
};

const getAll = async () => {
  return (await axios.get(`${HOST_URL}/owner`)).data;
};

// The owner pickers and the data stream grid share one 'getOwners' cache entry, so they
// have to agree on the order: whichever mounts first is the one that fetches.
const getAllSortedByName = async () => {
  const data = await getAll();
  return [...data].sort((a, b) => String(a.name).localeCompare(String(b.name)));
};

const post = async (data) => {
  return (await axios.post(`${HOST_URL}/owner`, data)).data;
};

const put = async (ownerId, data) => {
  return (await axios.put(`${HOST_URL}/owner/${ownerId}`, data)).data;
};

export default {getOneById, getAll, getAllSortedByName, post, put};